import { useQuery } from '@tanstack/react-query';

import { fetchOrganizationTags } from '@/api/v4/organization-tags.api';
import { fetchSpotlightCompanyTags } from '@/api/v4/spotlight.api';
import { QueryKey } from '@/config/query-client';

import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';

const companyTagsFetchers: Record<
  CompanyFetchMode,
  (organizationId: string) => ReturnType<typeof fetchOrganizationTags>
> = {
  general: organizationId => fetchOrganizationTags({ organizationId }),
  spotlight: fetchSpotlightCompanyTags,
};

export const useCompanyTags = (companyId: string | null) => {
  const fetchMode = useCompanyFetchMode();

  return useQuery({
    queryKey: [QueryKey.CountEntitiesByTag, fetchMode, companyId],
    queryFn: () =>
      companyId ? companyTagsFetchers[fetchMode](companyId) : undefined,
    enabled: !!companyId,
    staleTime: 1000 * 10,
  });
};
